import * as React from "react";
import { API_REFERENCE_ROUTE } from "./helpers";
import { Icon } from "./Icon";
import { RenderStructuredText } from "./RenderStructuredText";
import { BreadCrumb } from "./BreadCrumb";
import { Card, Flex, Grid } from "@radix-ui/themes";

export default function Guide({ post }) {
    const title = post.title;

    return <div className="flex">
        <article>
            <BreadCrumb title={title} />
            <Flex direction="column" gap="3">
                <Card className="banner-image-guides">
                    <Grid columns="2" align="center" gap="6" p="6">
                        <h1>{title}</h1>
                        {post?.bannerimagegraphic?.url && <img src={post.bannerimagegraphic.url}/>}
                    </Grid>
                </Card>
                <div className="endpoints">
                    {post.endpoints.length > 0 ? <>
                        <Flex direction="column" gap="0" mt="3" mb="6">
                            <div className="title">APIs used:</div><ul>
                                {post.endpoints.map((e, i) => {
                                    switch (e.__typename) {
                                        case "ApiendpointRecord":
                                            return <li key={i} className="label" onClick={() => {
                                                window.open(`/docs/${API_REFERENCE_ROUTE}/` + e.grouping + "/" + e.slug, "_blank");
                                            } }>{e.title} &nbsp; <Icon icon="new-window" /></li>;
                                        case "ClasscEndpointRecord": {
                                            const label = `${e.application.displayname}: ${e.name}`;
                                            return <li key={i} className="label" onClick={() => {
                                                window.open(`/docs/${API_REFERENCE_ROUTE}/` + e.application.slug + "/" + `${e.application.slug}-${e.endpointtype}` + "/", "_blank");
                                            } }>{label} &nbsp; <Icon icon="new-window" /></li>;
                                        }
                                        default:
                                            throw new Error("handle me: " + e.__typename);
                                    }
                                })}
                            </ul>
                        </Flex>
                    </>
                        :
                        null}
                   
                </div>
                <RenderStructuredText post={post} />
            </Flex>
        </article>
        <style jsx>
            {`

                    .endpoints ul {
                        list-style: none;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        gap: 0.5rem;
                    }

                    .endpoints li:hover{
                       background:var(--pink);
                       color:white;
                       transition-property: all;
                       transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                       transition-duration: 150ms; 
                       cursor:pointer; 
                    }

                    .endpoints .title {
                        margin-bottom: calc(var(--default-vertical-spacing) / 2);
                    }
                    .endpoints  .label {
                        min-height: 40px;
                        border: 1px solid var(--code-border);
                        border-radius: var(--border-radius);
                        padding: 8px 12px;
                    }
                    article {
                        margin-right: auto;
                    }
                        `}
        </style>
    </div>;

}
